const pbs_locations = {
	description:
		"Manage the available PBS locations for the client. The sliders can be used to determine if a node is available to for the client to create a free PBS and/or paid PBS. When both sliders are disabled, no new PBSs can be created by clients on that node. If all sliders of all nodes are disabled, the service does not work because then the client cannot select a country or location.",
	messages: {
		pbs_allow_free_updates: "Status for free PBSs successfully changed on node.",
		pbs_allow_paid_updates: "Status for paid PBSs successfully changed on node.",
	},
	node: {
		pbs_allow_free: {
			label: "Allow free PBSs on node",
		},
		pbs_allow_paid: {
			label: "Allow paid PBSs on node",
		},
		pbs_usage: {
			cant_fetch: "Not available",
			label: "PBS usage",
		},
	},
	title: "PBS site management",
};

export default pbs_locations;
